module.exports = __webpack_public_path__ + "img/keyOption_hover.94bdd50e.png";